import * as React from 'react';
import * as styles from './ContentOrganizerOptionsPanel.css';
import "../../../styles/BasicIA.css";
import "../../../styles/Sharepoint_4.css";
import { ContentOrganizerStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { LocalizationService } from "./../../../services/LocalizationService";

export interface IContentOrganizerOptionsPanelProps {
  contentOrganizerStore?: ContentOrganizerStore;
  onSelectedStep: (step) => void;
  disbaled?: boolean;
  onClick?: () => void;
}

export interface  IContentOrganizerOptionsPanelState {
}

@inject('contentOrganizerStore')
@observer
export class ContentOrganizerOptionsPanel extends React.Component<IContentOrganizerOptionsPanelProps, IContentOrganizerOptionsPanelState> {

  constructor(props: IContentOrganizerOptionsPanelProps) {
    super(props);
  }

  public render(): JSX.Element {

    let panel = (
    <div className={styles.IWizard_Panel}>
      <div>
        <div className={styles.IWizard_TitleContainer}>
        <div className={"IA_FontSize_24"}>
          {new LocalizationService().strings.ContentOrganizer_OptionsCreateTitle}
        </div>
        <div>
          <p className={"IA_FontSize_14"}>{new LocalizationService().strings.ContentOrganizer_OptionsCreateDescription}</p>
        </div>
      </div>
        <div 
        className={[styles.IWizard_ButtonsContainer, "IA_OnFocusOutline_outer"].join(" ")}
        tabIndex={0}
        onKeyPress={(event: React.KeyboardEvent<HTMLDivElement>) => {
          if (event.key === "Enter" && !this.props.disbaled) {
            this.props.onClick();
          }
        }}
        >
          <button 
          tabIndex={-1}
          className={[styles.IWizard_Button, "IA_OnFocusOutline_inner"].join(" ")}
          onClick={() => {
            this.props.contentOrganizerStore.newSiteCollection = true;
            this.props.contentOrganizerStore.setStep(1);
            this.props.onSelectedStep(1);
          }}        
          >
              <div className={styles.IWizard_Img}>
                <img src={"https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/wizard1.svg"}/>
              </div>
              <div
              style={{
                textAlign:"left", 
                marginLeft:"24px", 
                marginRight:"24px"
                }}>
                <span className={styles.IWizard_Headline}>{new LocalizationService().strings.ContentOrganizer_OptionsCreateNew}</span>
                <p>{new LocalizationService().strings.ContentOrganizer_OptionsCreateNewDescription}</p>
              </div>
          </button>
          <button 
          tabIndex={-2}
          className={[styles.IWizard_Button, "IA_OnFocusOutline_inner"].join(" ")}
          onClick={() => {
            this.props.contentOrganizerStore.newSiteCollection = false;
            this.props.contentOrganizerStore.setStep(1);
            this.props.onSelectedStep(1);
          }}
          >
            <div className={styles.IWizard_Img}>
              <img src={"https://intraactivestorage.blob.core.windows.net/cdn/SDK Images/wizard2.svg"}/>
            </div>
            <div 
            style={{
              textAlign:"left", 
              marginLeft:"24px", 
              marginRight:"24px"
              }}>
              <span className={styles.IWizard_Headline}>{new LocalizationService().strings.ContentOrganizer_OptionsCreateSelect}</span>
              <p>{new LocalizationService().strings.ContentOrganizer_OptionsCreateSelectDescription}</p>
            </div>
          </button>
        </div>
      </div>
    </div>);

    return panel;
  }


}
